import React from 'react';
import { PageType } from '../../../../types/api/PageType';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { translatePageType } from '../../PageType/PageTypeTitle';

type PageLeadPageTypeTranslation = {
  pageType: PageType;
  categories?: string[];
};

export const formatCategories = (categories?: string[]) => {
  if (categories && categories?.length > 0) {
    return `(${categories.join(', ')})`;
  }
  return '';
};

// we want to render whitelisted pageTypes for which we have translations
export function PageLeadPageTypeTranslation({ categories, pageType }: PageLeadPageTypeTranslation) {
  const { t } = useSonTranslation('glossary');

  const joinedCategories = formatCategories(categories);
  const faqExplanation = t('faqExplanation');

  const pageTypeText = translatePageType(pageType);
  if (pageType === PageType.faq || pageType === PageType.faqlist || pageType === PageType.faqlistpost) {
    return (
      <>
        <abbr title={faqExplanation} lang="en" className="page-lead__abbr">
          FAQ
        </abbr>
        {pageTypeText.split('FAQ')[1]}
        {joinedCategories ? ` ${joinedCategories}` : ''}
      </>
    );
  }
  return `${pageTypeText} ${formatCategories(categories)}`.trim();
}
